import { PasswordChangeFormDictionary } from 'types/i18n';

export const passwordChangeFormDictionaryRu: PasswordChangeFormDictionary = {
  currentPasswordInputLabel: 'Текущий пароль',
  nextPasswordInputLabel: 'Новый пароль',
  nextPasswordRepeatInputLabel: 'Подтвердите пароль',
};
